/**
 * @global
 * @namespace
 */
const EditComment = (function () {
	const _CONTAINER_SELECTOR = "#edit-comment-popup";
	var _forceSubmitContent = false;

	function open(sender, commentId, content) {
		_resetPopup(content);
		_setupAndOpenPopup(commentId);
	}

	function setError(error, forceSubmit) {
		_forceSubmitContent = forceSubmit;
		_resetErrors();
		_errorHandler(error);

		if (forceSubmit) {
			const $button = $(_CONTAINER_SELECTOR + " .icon-action-button, " + _CONTAINER_SELECTOR + " .primary-action-button");
			$button.text($button.data('force-text'));
		}
	}

	function success() {
		closePopup(_CONTAINER_SELECTOR);
	}

	function _setupAndOpenPopup(commentId) {
		const okAction = function (e) {
			e.preventDefault();
			e.stopImmediatePropagation();
			_submitRequest(commentId);
			return false;
		};

		const closeAction = function () {
			$(_CONTAINER_SELECTOR + " .icon-action-button, " + _CONTAINER_SELECTOR + " .primary-action-button").off("click", okAction);
		};

		$(_CONTAINER_SELECTOR + " .icon-action-button, " + _CONTAINER_SELECTOR + " .primary-action-button").on("click", okAction);
		openPopup(_CONTAINER_SELECTOR, closeAction);
	}

	function _submitRequest(commentId) {
		_showLoading();
		$('[name="editCommentContent"]').val($(_CONTAINER_SELECTOR + " #edit-comment-content").val());
		$('[name="editForceSubmitComment"]').val(_forceSubmitContent ? 1 : '');
		mvvm.doSubmit(null, "EditComment", commentId, function () { _hideLoading() });
	}

	function _resetPopup(content) {
		_forceSubmitContent = false;
		const $content = $(_CONTAINER_SELECTOR + " #edit-comment-content");
		$content.val(content);
		$content.trigger("input");

		const $button = $(_CONTAINER_SELECTOR + " .icon-action-button, " + _CONTAINER_SELECTOR + " .primary-action-button");
		$button.text($button.data('normal-text'));

		_resetErrors();
	}

	function _resetErrors() {
		const $errors = $(_CONTAINER_SELECTOR + " .error-list");
		$errors.children().remove();
		$errors.hide();
	}

	function _errorHandler(error) {
		_resetErrors();
		const $errors = $(_CONTAINER_SELECTOR + " .error-list");
		$errors.show();
		$errors.append("<li>" + error + "</li>");
	}

	function _showLoading() {
		$(_CONTAINER_SELECTOR).addClass('loading');
	}

	function _hideLoading() {
		$(_CONTAINER_SELECTOR).removeClass('loading');
	}

	return {
		open: open,
		setError: setError,
		success: success,
	};
}());
